import { clubStorage, confirmedClub } from './club-session';
/**
 * Squad & Tactics State (Microservicio de Plantillas, Clubes y Tácticas)
 * Gestiona el club del usuario, jugadores de la plantilla, agentes libres,
 * estrellas rivales y la alineación táctica interactiva sobre el césped.
 */
import { Injectable, signal, computed, inject } from '@angular/core';
import {
  Club,
  Player,
  LineupSlot,
  Position,
  BackendSquadPlayer,
  BackendSquadResponse,
  BackendMarketPlayer,
  BackendMarketListingResponse,
  BackendFormation,
  BackendFormationSlot,
  ClubLineupResponse,
  SaveLineupPayload,
  LineupSelectionResponse,
  SaveLineupSelectionPayload,
  ClubShieldConfig,
  getUnavailabilityTypeLabel,
  getUnavailabilityReasonLabel,
} from '../models/types';
import {
  INITIAL_USER_CLUB,
  LEAGUE_CLUBS,
  INITIAL_USER_SQUAD,
  INITIAL_FREE_AGENTS,
  OPPONENT_STARS,
  USER_CLUB_ID,
} from '../../../data/initialData';
import { UiState } from './ui.state';
import { clubsApi } from '../http/clubs.api';
import { marketApi } from '../http/market.api';
import { squadApi } from '../http/squad.api';
import { CompetitionService } from '../http/competition.service';

export type TacticalFormation = '4-4-2' | '4-3-3' | '4-2-3-1' | '3-4-3' | '3-5-2' | string;

export const FORMATION_SLOTS: Record<
  string,
  { id: string; pos: Position; label: string; x: number; y: number }[]
> = {
  '4-4-2': [
    { id: 'slot-1', pos: 'POR', label: 'POR', x: 50, y: 90 },
    { id: 'slot-2', pos: 'DEF', label: 'LI', x: 20, y: 73 },
    { id: 'slot-3', pos: 'DEF', label: 'DFC', x: 40, y: 73 },
    { id: 'slot-4', pos: 'DEF', label: 'DFC', x: 60, y: 73 },
    { id: 'slot-5', pos: 'DEF', label: 'LD', x: 80, y: 73 },
    { id: 'slot-6', pos: 'MED', label: 'MI', x: 20, y: 45 },
    { id: 'slot-7', pos: 'MED', label: 'MC', x: 40, y: 45 },
    { id: 'slot-8', pos: 'MED', label: 'MC', x: 60, y: 45 },
    { id: 'slot-9', pos: 'MED', label: 'MD', x: 80, y: 45 },
    { id: 'slot-10', pos: 'DEL', label: 'DC', x: 33, y: 17 },
    { id: 'slot-11', pos: 'DEL', label: 'DC', x: 67, y: 17 },
  ],
  '4-3-3': [
    { id: 'slot-1', pos: 'POR', label: 'POR', x: 50, y: 90 },
    { id: 'slot-2', pos: 'DEF', label: 'LI', x: 20, y: 73 },
    { id: 'slot-3', pos: 'DEF', label: 'DFC', x: 40, y: 73 },
    { id: 'slot-4', pos: 'DEF', label: 'DFC', x: 60, y: 73 },
    { id: 'slot-5', pos: 'DEF', label: 'LD', x: 80, y: 73 },
    { id: 'slot-6', pos: 'MED', label: 'MC', x: 25, y: 45 },
    { id: 'slot-7', pos: 'MED', label: 'MCD', x: 50, y: 55 },
    { id: 'slot-8', pos: 'MED', label: 'MC', x: 75, y: 45 },
    { id: 'slot-9', pos: 'DEL', label: 'EI', x: 25, y: 17 },
    { id: 'slot-10', pos: 'DEL', label: 'DC', x: 50, y: 17 },
    { id: 'slot-11', pos: 'DEL', label: 'ED', x: 75, y: 17 },
  ],
  '4-2-3-1': [
    { id: 'slot-1', pos: 'POR', label: 'POR', x: 50, y: 90 },
    { id: 'slot-2', pos: 'DEF', label: 'LI', x: 20, y: 73 },
    { id: 'slot-3', pos: 'DEF', label: 'DFC', x: 40, y: 73 },
    { id: 'slot-4', pos: 'DEF', label: 'DFC', x: 60, y: 73 },
    { id: 'slot-5', pos: 'DEF', label: 'LD', x: 80, y: 73 },
    { id: 'slot-6', pos: 'MED', label: 'MCD', x: 33, y: 55 },
    { id: 'slot-7', pos: 'MED', label: 'MCD', x: 67, y: 55 },
    { id: 'slot-8', pos: 'MED', label: 'MI', x: 25, y: 35 },
    { id: 'slot-9', pos: 'MED', label: 'MCO', x: 50, y: 35 },
    { id: 'slot-10', pos: 'MED', label: 'MD', x: 75, y: 35 },
    { id: 'slot-11', pos: 'DEL', label: 'DC', x: 50, y: 17 },
  ],
  '3-4-3': [
    { id: 'slot-1', pos: 'POR', label: 'POR', x: 50, y: 90 },
    { id: 'slot-2', pos: 'DEF', label: 'DFC', x: 25, y: 73 },
    { id: 'slot-3', pos: 'DEF', label: 'DFC', x: 50, y: 73 },
    { id: 'slot-4', pos: 'DEF', label: 'DFC', x: 75, y: 73 },
    { id: 'slot-5', pos: 'MED', label: 'MI', x: 20, y: 45 },
    { id: 'slot-6', pos: 'MED', label: 'MC', x: 40, y: 45 },
    { id: 'slot-7', pos: 'MED', label: 'MC', x: 60, y: 45 },
    { id: 'slot-8', pos: 'MED', label: 'MD', x: 80, y: 45 },
    { id: 'slot-9', pos: 'DEL', label: 'EI', x: 25, y: 17 },
    { id: 'slot-10', pos: 'DEL', label: 'DC', x: 50, y: 17 },
    { id: 'slot-11', pos: 'DEL', label: 'ED', x: 75, y: 17 },
  ],
  '3-5-2': [
    { id: 'slot-1', pos: 'POR', label: 'POR', x: 50, y: 90 },
    { id: 'slot-2', pos: 'DEF', label: 'DFC', x: 25, y: 73 },
    { id: 'slot-3', pos: 'DEF', label: 'DFC', x: 50, y: 73 },
    { id: 'slot-4', pos: 'DEF', label: 'DFC', x: 75, y: 73 },
    { id: 'slot-5', pos: 'MED', label: 'MI', x: 17, y: 45 },
    { id: 'slot-6', pos: 'MED', label: 'MC', x: 33, y: 45 },
    { id: 'slot-7', pos: 'MED', label: 'MCD', x: 50, y: 55 },
    { id: 'slot-8', pos: 'MED', label: 'MC', x: 67, y: 45 },
    { id: 'slot-9', pos: 'MED', label: 'MD', x: 83, y: 45 },
    { id: 'slot-10', pos: 'DEL', label: 'DC', x: 33, y: 17 },
    { id: 'slot-11', pos: 'DEL', label: 'DC', x: 67, y: 17 },
  ],
};

const STORAGE_KEY = 'football_manager_real_v01';

@Injectable({
  providedIn: 'root',
})
export class SquadState {
  private readonly ui = inject(UiState);
  private readonly competition = inject(CompetitionService);
  readonly transferPending = signal<ReadonlySet<string>>(new Set());

  constructor() {
    void this.loadClubShield('1b296210-fd7d-5202-a17f-657bd97aec7b');
    if (typeof clubStorage !== 'undefined') {
      const storedId = clubStorage.getItem('fm_real_user_club_id');
      if (storedId && storedId !== '1b296210-fd7d-5202-a17f-657bd97aec7b') {
        void this.loadClubShield(storedId);
      }
    }
  }

  // Clubs and player rosters
  readonly clubs = signal<Club[]>(this.getInitialClubs());
  readonly allPlayers = signal<Player[]>(this.getInitialPlayers());
  readonly availableFormations = signal<string[]>(['4-4-2', '4-3-3', '4-2-3-1', '3-4-3', '3-5-2']);
  readonly formationsData = signal<BackendFormation[]>([]);
  readonly isFormationsLoading = signal<boolean>(false);
  readonly activeFormation = signal<TacticalFormation>('4-3-3');
  readonly lineupSlots = signal<LineupSlot[]>(this.getInitialLineupSlots());
  readonly lineupVersion = signal<number>(1);
  readonly lineupBench = signal<string[]>([]);
  readonly lineupSelectionVersion = signal<number>(0);
  readonly isLineupSelectionLoaded = signal<boolean>(false);
  readonly isSquadLoading = signal<boolean>(false);
  readonly activeUserClubId = signal<string | null>(null);
  readonly activeDivisionName = signal<string>(this.getInitialDivisionName());
  readonly loadedSquadClubId = signal<string | null>(null);

  // Market & Free Agents listing state
  readonly marketListingInfo = signal<{
    id: string;
    competitionUnitId: string;
    marketDate: string;
    generatedAt: string;
    closesAt?: string;
    closes_at?: string;
  } | null>(null);
  readonly isMarketLoading = signal<boolean>(false);
  readonly marketError = signal<string | null>(null);

  // Shield configurations per club
  readonly userShieldMap = signal<Record<string, ClubShieldConfig>>({});

  async loadClubShield(clubId: string): Promise<ClubShieldConfig | null> {
    if (!clubId) return null;
    try {
      const shield = await clubsApi.getClubShield(clubId);
      if (shield) {
        this.userShieldMap.update((prev) => ({ ...prev, [clubId]: shield }));
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem(`lom_club_shield_${clubId}`, JSON.stringify(shield));
        }
        return shield;
      }
    } catch {}
    return null;
  }

  // Active user club ID provider
  private userClubIdProvider: () => string | undefined = () => undefined;
  private onUserClubChangeCallback?: (clubId: string) => void;

  setUserClubIdProvider(provider: () => string | undefined) {
    this.userClubIdProvider = provider;
  }

  setOnUserClubChange(cb: (clubId: string) => void) {
    this.onUserClubChangeCallback = cb;
  }

  setActiveUserClubId(clubId: string | null): void {
    this.activeUserClubId.set(clubId);
    if (typeof clubStorage !== 'undefined') {
      if (clubId) {
        clubStorage.setItem('fm_real_user_club_id', clubId);
      } else {
        clubStorage.removeItem('fm_real_user_club_id');
      }
    }
    if (clubId) {
      void this.loadClubShield(clubId);
      this.clubs.update((prev) => {
        const matchingIndex = prev.findIndex((c) => c.id === clubId || c.isUser);
        if (matchingIndex >= 0) {
          const next = prev.map((c, idx) =>
            idx === matchingIndex ? { ...c, id: clubId, isUser: true } : c
          );
          this.persist(`${STORAGE_KEY}_clubs`, next);
          return next;
        }
        return prev;
      });
      if (clubId !== 'default') {
        this.onUserClubChangeCallback?.(clubId);
      }
    }
  }

  setUserClubDivision(division: string): void {
    if (!division) return;
    this.activeDivisionName.set(division);
    if (typeof clubStorage !== 'undefined') {
      clubStorage.setItem('fm_real_division_name', division);
    }
  }

  setUserClubInfo(name?: string, division?: string, code?: string): void {
    if (division) {
      this.setUserClubDivision(division);
    }
    if (name && typeof clubStorage !== 'undefined') {
      clubStorage.setItem('fm_real_club_name', name);
    }
    if (code && typeof clubStorage !== 'undefined') {
      clubStorage.setItem('fm_real_club_code', code);
    }
  }

  resetClubState(): void {
    this.activeUserClubId.set(null);
    this.activeDivisionName.set('10ª División');
    this.loadedSquadClubId.set(null);
    this.marketListingInfo.set(null);
    if (typeof clubStorage !== 'undefined') {
      clubStorage.removeItem('fm_real_user_club_id');
      clubStorage.removeItem('fm_real_club_name');
      clubStorage.removeItem('fm_real_club_code');
      clubStorage.removeItem('fm_real_division_name');
    }
  }

  private getInitialDivisionName(): string {
    if (typeof clubStorage !== 'undefined') {
      const saved = clubStorage.getItem('fm_real_division_name');
      if (saved && saved !== 'Primera División') return saved;
    }
    return '10ª División';
  }

  // Computed signals
  readonly userClub = computed<Club>(() => {
    const clubList = this.clubs();
    const targetedClubId = this.activeUserClubId() || this.userClubIdProvider();
    const activeDiv = this.activeDivisionName();
    const isPrivate = confirmedClub()?.mode === 'PRIVATE';
    const storedClubName = typeof clubStorage !== 'undefined' ? clubStorage.getItem('fm_real_club_name') : null;
    const storedClubCode = typeof clubStorage !== 'undefined' ? clubStorage.getItem('fm_real_club_code') : null;

    const getStoredShield = (clubId: string) => {
      const loaded = this.userShieldMap()[clubId];
      if (loaded) return loaded;
      try {
        if (typeof localStorage !== 'undefined') {
          const saved = localStorage.getItem(`lom_club_shield_${clubId}`);
          if (saved) return JSON.parse(saved);
        }
      } catch {}
      return {
        templateId: 'MAD',
        primaryColor: '#EE7500',
        secondaryColor: '#0046EB',
        initials: 'BUR',
      };
    };

    if (targetedClubId) {
      const getCachedEconomy = (clubId: string, baseEconomy: any) => {
        if (typeof clubStorage !== 'undefined') {
          const storedBal = clubStorage.getItem(`fm_real_club_balance_${clubId}`);
          if (storedBal) {
            try {
              const parsed = JSON.parse(storedBal);
              const avM = +(parsed.availableBalance / 1_000_000).toFixed(3);
              const resM = +(parsed.reservedBalance / 1_000_000).toFixed(3);
              const totM = +(parsed.totalBalance / 1_000_000).toFixed(3);
              return {
                ...baseEconomy,
                availableBalance: avM,
                reservedBalance: resM,
                totalBalance: totM,
                currency: parsed.currency || 'EUR',
                version: parsed.version,
              };
            } catch {}
          }
        }
        return baseEconomy;
      };

      const found = clubList.find((c) => c.id === targetedClubId) || clubList.find((c) => c.isUser);
      if (found) {
        const economyToUse =
          found.economy?.availableBalance === 100.0
            ? getCachedEconomy(targetedClubId, found.economy)
            : found.economy;

        const baseStadium = found.stadium || INITIAL_USER_CLUB.stadium;
        const stadiumToUse = {
          ...INITIAL_USER_CLUB.stadium,
          ...baseStadium,
          capacity: baseStadium?.capacity ?? INITIAL_USER_CLUB.stadium.capacity,
          name: baseStadium?.name || INITIAL_USER_CLUB.stadium.name,
          ticketPrice: baseStadium?.ticketPrice ?? INITIAL_USER_CLUB.stadium.ticketPrice,
          seasonTicketPrice: baseStadium?.seasonTicketPrice ?? INITIAL_USER_CLUB.stadium.seasonTicketPrice,
          seasonTicketHolders: baseStadium?.seasonTicketHolders ?? INITIAL_USER_CLUB.stadium.seasonTicketHolders,
          modules: {
            ...INITIAL_USER_CLUB.stadium.modules,
            ...(baseStadium?.modules || {}),
          },
        };

        const shieldConfig = getStoredShield(targetedClubId) || found.shield || null;
        return {
          ...found,
          id: targetedClubId,
          isUser: true,
          name: storedClubName || found.name,
          code: storedClubCode || (isPrivate ? (storedClubName || found.name || '').slice(0,3).toUpperCase() : found.code),
          division: isPrivate ? '' : (activeDiv || found.division || ''),
          stadium: stadiumToUse,
          economy: economyToUse,
          shield: shieldConfig,
          primaryColor: shieldConfig?.primaryColor || found.primaryColor,
          secondaryColor: shieldConfig?.secondaryColor || found.secondaryColor,
        };
      }

      // If activeUserClubId is set from real backend but not yet in mock clubList, create a club wrapper
      const fallbackShield = getStoredShield(targetedClubId);
      return {
        ...INITIAL_USER_CLUB,
        id: targetedClubId,
        name: storedClubName || INITIAL_USER_CLUB.name,
        code: storedClubCode || (isPrivate ? (storedClubName || '').slice(0,3).toUpperCase() : INITIAL_USER_CLUB.code),
        division: isPrivate ? '' : (activeDiv || ''),
        isUser: true,
        stadium: {
          ...INITIAL_USER_CLUB.stadium,
          modules: { ...INITIAL_USER_CLUB.stadium.modules },
        },
        economy: getCachedEconomy(targetedClubId, INITIAL_USER_CLUB.economy),
        shield: fallbackShield || null,
        primaryColor: fallbackShield?.primaryColor || INITIAL_USER_CLUB.primaryColor,
        secondaryColor: fallbackShield?.secondaryColor || INITIAL_USER_CLUB.secondaryColor,
      };
    }

    const base = (
      clubList.find((c) => c.isUser) ||
      clubList.find((c) => c.id === USER_CLUB_ID) ||
      INITIAL_USER_CLUB
    );
    const baseId = base.id || USER_CLUB_ID;
    const baseShield = getStoredShield(baseId) || (base as any).shield || null;
    return {
      ...base,
      name: storedClubName || base.name,
      code: storedClubCode || base.code,
      division: activeDiv || base.division || '10ª División',
      shield: baseShield,
      primaryColor: baseShield?.primaryColor || base.primaryColor,
      secondaryColor: baseShield?.secondaryColor || base.secondaryColor,
    };
  });

  readonly userSquad = computed<Player[]>(() => {
    const club = this.userClub();
    const clubPlayers = this.allPlayers().filter((p) => p.clubId === club.id);
    if (clubPlayers.length > 0) {
      return clubPlayers;
    }
    // Fallback: Si loadedSquadClubId tiene futbolistas cargados, utilizarlos
    const loadedId = this.loadedSquadClubId();
    if (loadedId) {
      const loadedPlayers = this.allPlayers().filter((p) => p.clubId === loadedId);
      if (loadedPlayers.length > 0) {
        return loadedPlayers;
      }
    }
    return clubPlayers;
  });

  readonly freeAgents = computed<Player[]>(() => {
    return this.allPlayers().filter((p) => p.clubId === null);
  });

  readonly opponentStars = computed<Player[]>(() => {
    const club = this.userClub();
    return this.allPlayers().filter(
      (p) => p.clubId !== null && p.clubId !== club.id
    );
  });

  /**
   * GET /api/squads/formations
   * Recupera las formaciones tácticas disponibles y sus coordenadas de slots del backend.
   */
  async fetchFormations(forceRefresh: boolean = false): Promise<BackendFormation[]> {
    if (!forceRefresh && this.formationsData().length > 0) {
      return this.formationsData();
    }

    this.isFormationsLoading.set(true);
    try {
      const formations = await squadApi.getFormations();
      if (formations && Array.isArray(formations) && formations.length > 0) {
        this.formationsData.set(formations);
        this.availableFormations.set(formations.map((f) => f.code));

        // Actualizar dinámicamente FORMATION_SLOTS con las posiciones y coordenadas recibidas
        for (const f of formations) {
          FORMATION_SLOTS[f.code] = f.slots.map((s) => ({
            id: `slot-${s.slot}`,
            pos: this.mapBackendPosition(s.assignedPosition),
            label: s.label,
            x: Math.round(s.x * 100),
            y: Math.round(s.y * 100),
          }));
        }
      }
      return formations;
    } catch (err: any) {
      console.warn('No se pudieron obtener las formaciones desde la API, usando predeterminadas:', err);
      return [];
    } finally {
      this.isFormationsLoading.set(false);
    }
  }

  setFormation(formation: TacticalFormation): void {
    this.activeFormation.set(formation);
    const template = FORMATION_SLOTS[formation] || FORMATION_SLOTS['4-4-2'] || FORMATION_SLOTS['4-3-3'];
    const oldSlots = this.lineupSlots();
    const assignedPlayerIds = oldSlots
      .map((s) => s.playerId)
      .filter(Boolean) as string[];

    const newSlots: LineupSlot[] = template.map((slot, index) => {
      const existing = oldSlots[index]?.playerId;
      return {
        slotId: slot.id,
        position: slot.pos,
        x: slot.x,
        y: slot.y,
        label: slot.label,
        playerId: existing || assignedPlayerIds[index] || null,
      };
    });

    this.lineupSlots.set(newSlots);
    this.persist(`${STORAGE_KEY}_lineup`, newSlots);
    this.ui.showNotification(`Formación cambiada a ${formation}`, 'info');
  }

  assignPlayerToSlot(slotId: string, playerId: string | null): void {
    if (playerId !== null && this.lineupBench().includes(playerId)) {
      this.lineupBench.update((bench) => bench.filter((id) => id !== playerId));
      const clubId = this.activeUserClubId() || this.userClub().id || 'default';
      this.persist(`${STORAGE_KEY}_${clubId}_bench`, this.lineupBench());
    }
    const updated = this.lineupSlots().map((slot) => {
      if (
        slot.playerId === playerId &&
        playerId !== null &&
        slot.slotId !== slotId
      ) {
        return { ...slot, playerId: null };
      }
      if (slot.slotId === slotId) {
        return { ...slot, playerId };
      }
      return slot;
    });

    this.lineupSlots.set(updated);
    this.persist(`${STORAGE_KEY}_lineup`, updated);
  }

  addBenchPlayer(playerId: string): boolean {
    if (!playerId) return false;
    const starterIds = new Set(this.lineupSlots().map((s) => s.playerId).filter(Boolean));
    if (starterIds.has(playerId)) {
      this.ui.showNotification('El jugador ya forma parte del once titular', 'warning');
      return false;
    }
    const currentBench = this.lineupBench();
    if (currentBench.includes(playerId)) {
      return false;
    }
    if (currentBench.length >= 5) {
      this.ui.showNotification('El banquillo admite un máximo de 5 suplentes', 'warning');
      return false;
    }
    this.lineupBench.update((prev) => [...prev, playerId]);
    const clubId = this.activeUserClubId() || this.userClub().id || 'default';
    this.persist(`${STORAGE_KEY}_${clubId}_bench`, this.lineupBench());
    return true;
  }

  removeBenchPlayer(playerId: string): void {
    this.lineupBench.update((prev) => prev.filter((id) => id !== playerId));
    const clubId = this.activeUserClubId() || this.userClub().id || 'default';
    this.persist(`${STORAGE_KEY}_${clubId}_bench`, this.lineupBench());
  }

  toggleBenchPlayer(playerId: string): void {
    if (this.lineupBench().includes(playerId)) {
      this.removeBenchPlayer(playerId);
    } else {
      this.addBenchPlayer(playerId);
    }
  }

  clearBench(): void {
    this.lineupBench.set([]);
    const clubId = this.activeUserClubId() || this.userClub().id || 'default';
    this.persist(`${STORAGE_KEY}_${clubId}_bench`, []);
  }

  /**
   * 1. GET /api/clubs/{clubId}/lineup-selection (o fallback a /lineup)
   * Consulta formación, once titulares y suplentes habituales del club.
   */
  async fetchClubLineup(
    clubId: string,
    forceRefresh: boolean = false
  ): Promise<any | null> {
    if (!clubId || clubId === 'default') return null;

    // Intentar GET /api/clubs/{clubId}/lineup-selection
    try {
      const selection = await squadApi.getLineupSelection(clubId);
      if (selection && selection.players && Array.isArray(selection.players) && selection.players.length === 11) {
        if (selection.formation) {
          this.activeFormation.set(selection.formation);
        }
        const v = typeof selection.version === 'number' ? selection.version : 0;
        this.lineupSelectionVersion.set(v);
        this.lineupVersion.set(v);
        this.isLineupSelectionLoaded.set(true);

        const template =
          FORMATION_SLOTS[selection.formation] ||
          FORMATION_SLOTS['4-4-2'] ||
          FORMATION_SLOTS['4-3-3'];
        const playerMap = new Map<number, string>();
        for (const p of selection.players) {
          playerMap.set(p.slot, p.playerInstanceId);
        }

        const newSlots: LineupSlot[] = template.map((slot, index) => {
          const slotNum = index + 1;
          const assignedId = playerMap.get(slotNum) || null;
          return {
            slotId: slot.id,
            position: slot.pos,
            x: slot.x,
            y: slot.y,
            label: slot.label,
            playerId: assignedId,
          };
        });

        this.lineupSlots.set(newSlots);

        // Suplentes de banquillo (0 a 5)
        const benchList = Array.isArray(selection.bench) ? selection.bench.slice(0, 5) : [];
        this.lineupBench.set(benchList);

        this.persist(`${STORAGE_KEY}_${clubId}_lineup`, newSlots);
        this.persist(`${STORAGE_KEY}_${clubId}_bench`, benchList);
        this.persist(`${STORAGE_KEY}_${clubId}_lineup_version`, v);
        return selection;
      }
    } catch (err: any) {
      if (err?.status === 404 || err?.code === 'LINEUP_NOT_FOUND') {
        // Confirmado que todavía no existe selección habitual: versión 0
        this.lineupSelectionVersion.set(0);
        this.isLineupSelectionLoaded.set(true);
      } else {
        // Error de red u otro error de servidor: no asumir versión 0 ni ausencia de alineación
        console.warn('[SquadState] Error en lineup-selection:', err);
      }
    }

    // Fallback secundario si aún no tiene lineup-selection pero existe alineación previa
    try {
      const res = await squadApi.getClubLineup(clubId);
      if (res && res.players && Array.isArray(res.players) && res.players.length > 0) {
        if (res.formation) {
          this.activeFormation.set(res.formation);
        }
        if (typeof res.version === 'number') {
          this.lineupVersion.set(res.version);
        } else if (typeof res.formationVersion === 'number') {
          this.lineupVersion.set(res.formationVersion);
        }

        const template =
          FORMATION_SLOTS[res.formation] ||
          FORMATION_SLOTS['4-4-2'] ||
          FORMATION_SLOTS['4-3-3'];
        const playerMap = new Map<number, string>();
        for (const p of res.players) {
          playerMap.set(p.slot, p.playerInstanceId);
        }

        const newSlots: LineupSlot[] = template.map((slot, index) => {
          const slotNum = index + 1;
          const assignedId = playerMap.get(slotNum) || null;
          return {
            slotId: slot.id,
            position: slot.pos,
            x: slot.x,
            y: slot.y,
            label: slot.label,
            playerId: assignedId,
          };
        });

        this.lineupSlots.set(newSlots);
        this.persist(`${STORAGE_KEY}_${clubId}_lineup`, newSlots);
        this.persist(`${STORAGE_KEY}_${clubId}_lineup_version`, this.lineupVersion());
        return res;
      }
      return null;
    } catch (err: any) {
      return null;
    }
  }

  /**
   * 2. POST /api/clubs/{clubId}/lineup/auto
   * Devuelve una propuesta de alineación para la formación especificada.
   */
  async autoPickLineup(formation?: string): Promise<void> {
    const targetClubId = this.activeUserClubId() || this.userClub().id;
    const targetFormation = formation || this.activeFormation();

    try {
      if (!targetClubId || targetClubId === 'default') {
        throw new Error('Selecciona un club para generar el once.');
      }
      const res = await squadApi.autoPickLineup(targetClubId, targetFormation);
      const formationCode = res?.formation || targetFormation;
      const template = FORMATION_SLOTS[formationCode];
      if (!template || !Array.isArray(res?.players) || res.players.length !== template.length ||
          new Set(res.players.map(p => p.playerInstanceId)).size !== template.length ||
          !template.every((_, index) => res.players.some(p => p.slot === index + 1 && p.playerInstanceId))) {
        throw new Error('El servidor no ha devuelto un once completo válido.');
      }
      const playerMap = new Map(res.players.map(p => [p.slot, p.playerInstanceId]));
      const newSlots: LineupSlot[] = template.map((slot, index) => ({
        slotId: slot.id,
        position: slot.pos,
        x: slot.x,
        y: slot.y,
        label: slot.label,
        playerId: playerMap.get(index + 1)!,
      }));
      this.activeFormation.set(formationCode);
      this.lineupSlots.set(newSlots);

      // Quitar del banquillo a cualquier jugador que haya sido elegido como titular
      const starterIds = new Set(newSlots.map((s) => s.playerId).filter(Boolean));
      this.lineupBench.update((bench) => bench.filter((id) => !starterIds.has(id)));
      this.persist(`${STORAGE_KEY}_${targetClubId}_bench`, this.lineupBench());

      this.persist(`${STORAGE_KEY}_${targetClubId}_lineup`, newSlots);
      this.ui.showNotification('Alineación optimizada automáticamente', 'success');
    } catch (err: any) {
      const code = err?.code || err?.responseBody?.code;
      const message = err?.status === 422 && code === 'INVALID_LINEUP'
        ? `No se ha podido completar un once válido para el ${targetFormation}. Comprueba que tienes al menos once jugadores distintos. Se mantiene tu once actual.`
        : 'No se ha podido generar el once. Se mantiene tu alineación actual. Inténtalo de nuevo.';
      this.ui.showNotification(message, 'error');
    }
  }
  async listPlayerForSale(playerId: string, askingPrice: number): Promise<boolean> {
    return this.changeTransferListing(playerId, async () => {
      const euros = Math.round(askingPrice * 1_000_000 * 100) / 100;
      if (!Number.isFinite(euros) || euros < 0.01) throw new Error('Introduce un precio mayor que cero.');
      const player = this.allPlayers().find(p => p.id === playerId);
      const listing = await marketApi.createClubListing(player?.playerInstanceId || playerId, euros);
      this.allPlayers.update(players => players.map(p => p.id === playerId
        ? { ...p, listedForTransfer: true, listingId: listing.id, askingPrice: listing.askingPrice == null ? undefined : listing.askingPrice / 1_000_000 } : p));
      this.ui.showNotification('Jugador añadido a la lista de transferibles', 'success');
    });
  }

  async removePlayerFromSale(playerId: string): Promise<boolean> {
    return this.changeTransferListing(playerId, async () => {
      const player = this.allPlayers().find(p => p.id === playerId);
      let listingId = player?.listingId;
      if (!listingId) {
        const unit = await this.competition.getSelectedClubId();
        if (!unit || !player?.clubId) throw new Error('No se pudo identificar la competición del jugador.');
        listingId = (await marketApi.getClubListings(unit)).find(l =>
          l.status === 'ACTIVE' && l.sellerClubId === player.clubId &&
          l.playerInstanceId === (player.playerInstanceId || playerId))?.id;
      }
      if (listingId) await marketApi.cancelClubListing(listingId);
      this.allPlayers.update(players => players.map(p => p.id === playerId
        ? { ...p, listedForTransfer: false, listingId: undefined, askingPrice: undefined } : p));
      this.ui.showNotification('Jugador retirado de transferibles', 'success');
    });
  }

  private async changeTransferListing(playerId: string, action: () => Promise<void>): Promise<boolean> {
    if (this.transferPending().has(playerId)) return false;
    this.transferPending.update(ids => new Set([...ids, playerId]));
    try {
      await action();
      return true;
    } catch (error: any) {
      this.ui.showNotification(error?.message || 'No se pudo actualizar el estado de transferible.', 'error');
      return false;
    } finally {
      this.transferPending.update(ids => new Set([...ids].filter(id => id !== playerId)));
    }
  }

  private async refreshTransferListings(clubId: string): Promise<void> {
    const unit = await this.competition.getSelectedClubId();
    if (!unit) throw new Error('No se pudo identificar la competición para consultar los transferibles.');
    const listings = await marketApi.getClubListings(unit);
    const byPlayer = new Map(listings.filter(l => l.sellerClubId === clubId && l.status === 'ACTIVE')
      .map(l => [l.playerInstanceId, l]));
    this.allPlayers.update(players => players.map(p => {
      if (p.clubId !== clubId || this.transferPending().has(p.id)) return p;
      const listing = byPlayer.get(p.playerInstanceId || p.id);
      return { ...p, listedForTransfer: !!listing, listingId: listing?.id,
        askingPrice: listing?.askingPrice == null ? undefined : listing.askingPrice / 1_000_000 };
    }));
  }

  /**
   * GET /api/clubs/{clubId}/squad
   * Consulta la plantilla de futbolistas del club desde el backend real.
   * Si ya fue cargada y almacenada en la store de señales (allPlayers), reutiliza la caché local
   * para no saturar el backend, a menos que se fuerce con forceRefresh=true.
   */
  async fetchSquadForClub(clubId: string, forceRefresh: boolean = false): Promise<Player[]> {
    // Si ya tenemos los futbolistas del club en la store y coincide el club cargado, no llamamos al backend
    if (!forceRefresh && this.loadedSquadClubId() === clubId) {
      const cached = this.allPlayers().filter((p) => p.clubId === clubId);
      if (cached.length > 0) {
        try { await this.refreshTransferListings(clubId); }
        catch (error: any) { this.ui.showNotification(error?.message || 'No se pudieron consultar los transferibles.', 'error'); }
        return this.allPlayers().filter(p => p.clubId === clubId);
      }
    }

    this.isSquadLoading.set(true);
    try {
      const res = await clubsApi.getClubSquad(clubId);
      const rawPlayers: BackendSquadPlayer[] = Array.isArray(res) ? res : (res?.players || []);

      const mappedPlayers: Player[] = rawPlayers.map((p, idx) => {
        const mappedPosition = this.mapBackendPosition(p.position);
        const age = p.age ?? (21 + (idx % 12));
        const rawVal = p.currentMarketValue ?? (p as any).marketValue ?? 0;
        const marketValM =
          rawVal >= 10000
            ? Number((rawVal / 1_000_000).toFixed(2))
            : Number(Number(rawVal).toFixed(2));
        const salary = p.salary ?? Number((1.2 + (idx % 5) * 0.4).toFixed(2));
        const releaseClause = p.releaseClause ?? Number((15 + (idx % 7) * 5).toFixed(1));
        const displayName = p.displayName || (p as any).name || `Jugador ${idx + 1}`;
        const realClub = p.realClub || null;
        const rawUnavs = Array.isArray(p.unavailabilities) ? p.unavailabilities : [];
        const unavailabilities = rawUnavs.map((u) => ({
          ...u,
          typeLabel: getUnavailabilityTypeLabel(u.type),
          reasonLabel: getUnavailabilityReasonLabel(u.reason),
        }));

        return {
          id: p.id,
          playerInstanceId: p.id,
          name: displayName,
          shortName: displayName.split(' ').pop() || '',
          position: mappedPosition,
          overall: (p as any).overall || 78,
          age,
          nationality: (p as any).nationality || 'España',
          isAmateur: p.type === 'AMATEUR',
          clubId: clubId,
          realClub: realClub
            ? {
                id: realClub.id,
                name: realClub.name,
                shortName: realClub.shortName,
              }
            : undefined,
          clubName: realClub?.name,
          clubShortName: realClub?.shortName,
          currentMarketValue: marketValM,
          averagePoints: p.averagePoints !== undefined ? p.averagePoints : null,
          last3AveragePoints:
            p.last3AveragePoints !== undefined
              ? p.last3AveragePoints
              : p.averagePoints !== undefined
              ? p.averagePoints
              : null,
          rating: p.rating ?? null,
          ratedAppearances: p.ratedAppearances ?? 0,
          secondaryPositions: p.secondaryPositions || [],
          unavailabilities: unavailabilities,
          contract: {
            salary,
            durationYears: 3,
            releaseClause,
            acquisitionCost: marketValM,
            startSeason: 2026,
            endSeason: 2029,
          },
          listedForTransfer: false,
          askingPrice: releaseClause,
          formScore: 4,
          playerDefinitionId: p.playerDefinitionId,
          rawPosition: p.position,
          status: p.status,
          playerType: p.type,
          version: p.version ?? 1,
        };
      });

      // Replace or merge into allPlayers signal
      this.allPlayers.update((current) => {
        const others = current.filter((p) => p.clubId !== clubId);
        return [...others, ...mappedPlayers];
      });

      // Sync lineup slots if empty
      const currentSlots = this.lineupSlots();
      const hasAssigned = currentSlots.some((s) => s.playerId !== null);
      if (!hasAssigned && mappedPlayers.length >= 11) {
        const updatedSlots = currentSlots.map((slot, index) => ({
          ...slot,
          playerId: mappedPlayers[index]?.id || null,
        }));
        this.lineupSlots.set(updatedSlots);
      }

      this.loadedSquadClubId.set(clubId);
      try { await this.refreshTransferListings(clubId); }
      catch (error: any) { this.ui.showNotification(error?.message || 'No se pudieron consultar los transferibles.', 'error'); }

      this.ui.showNotification(
        `Plantilla cargada: ${mappedPlayers.length} jugadores`,
        'success'
      );
      return this.allPlayers().filter(p => p.clubId === clubId);
    } catch (err: any) {
      const msg = err?.message || 'Error al obtener la plantilla del club';
      this.ui.showNotification(msg, 'error');
      return [];
    } finally {
      this.isSquadLoading.set(false);
    }
  }

  setFreeAgents(
    players: Player[],
    listingInfo?: {
      id: string;
      competitionUnitId: string;
      marketDate: string;
      generatedAt: string;
      closesAt?: string;
      closes_at?: string;
    }
  ): void {
    if (listingInfo) {
      this.marketListingInfo.set(listingInfo);
    }
    this.allPlayers.update((prev) => {
      const nonFreeAgents = prev.filter((p) => p.clubId !== null);
      return [...nonFreeAgents, ...players];
    });
  }

  /**
   * GET /api/market/units/{competitionGroupId}/current-listing
   * Endpoint oficial que recupera la lista de agentes libres para la unidad de competición.
   * En los agentes libres no habrá cláusula de rescisión sino valor de mercado y opción de prima de fichaje.
   */
  async fetchFreeAgentsListing(
    competitionGroupId: string,
    forceRefresh: boolean = false
  ): Promise<Player[]> {
    if (
      !forceRefresh &&
      this.marketListingInfo()?.competitionUnitId === competitionGroupId &&
      this.freeAgents().length > 0
    ) {
      return this.freeAgents();
    }

    this.isMarketLoading.set(true);
    this.marketError.set(null);

    try {
      const res = await marketApi.getCurrentListing(competitionGroupId);
      const rawPlayers: any[] = res?.players || (res as any)?.items || [];
      const listingId = res?.id || (res as any)?.listingId;

      const mapped: Player[] = rawPlayers.map((p, idx) => {
        const mappedPos = this.mapBackendPosition(p.position || p.rawPosition);
        const rawVal = p.marketValue ?? p.basePrice ?? p.currentMarketValue ?? 5000000;
        // marketValue viene en EUR (ej. 5000000.00) -> 5.00 M€
        const marketValM =
          rawVal >= 10000
            ? Number((rawVal / 1_000_000).toFixed(2))
            : Number(rawVal.toFixed(2));
        const refSalary = p.salaryM ?? Number(Math.max(0.5, marketValM * 0.12).toFixed(2));
        const displayName = p.displayName || p.name || `Agente Libre ${idx + 1}`;
        const playerInstanceId = p.playerInstanceId || p.id || `free-agent-${idx + 1}`;
        const realClub = p.realClub || null;
        const rawUnavs = Array.isArray(p.unavailabilities) ? p.unavailabilities : [];
        const unavailabilities = rawUnavs.map((u) => ({
          ...u,
          typeLabel: getUnavailabilityTypeLabel(u.type),
          reasonLabel: getUnavailabilityReasonLabel(u.reason),
        }));

        return {
          id: playerInstanceId,
          playerInstanceId: playerInstanceId,
          listingId: listingId,
          playerDefinitionId: p.playerDefinitionId || p.id || `def-${idx + 1}`,
          name: displayName,
          shortName: displayName.split(' ').pop() || '',
          position: mappedPos,
          rawPosition: p.position || p.rawPosition || 'MIDFIELDER',
          overall: p.overall || 78,
          averagePoints: p.averagePoints !== undefined ? p.averagePoints : null,
          last3AveragePoints: p.last3AveragePoints !== undefined ? p.last3AveragePoints : null,
          age: p.age !== undefined && p.age !== null ? p.age : (22 + (idx % 10)),
          nationality: p.nationality || 'España',
          isAmateur: p.type === 'AMATEUR',
          clubId: null, // Agente Libre
          realClub: realClub
            ? {
                id: realClub.id,
                name: realClub.name,
                shortName: realClub.shortName,
              }
            : undefined,
          clubName: realClub?.name,
          clubShortName: realClub?.shortName,
          currentMarketValue: marketValM,
          unavailabilities: unavailabilities,
          contract: {
            salary: refSalary,
            durationYears: 3,
            releaseClause: 0, // En los agentes libres NO HABRÁ cláusula de rescisión
            acquisitionCost: 0,
            startSeason: 1,
            endSeason: 4,
            signingBonus: 0,
          },
          listedForTransfer: false,
          formScore: 4,
          playerType: p.type || 'REAL',
          version: p.expectedVersion ?? p.version ?? 0,
        };
      });

      if (listingId && typeof clubStorage !== 'undefined') {
        clubStorage.setItem('fm_real_market_listing_id', listingId);
      }

      const resClosesAt = res?.closesAt || res?.closes_at;
      this.setFreeAgents(mapped, {
        id: listingId || res?.id || '5f7df771-b3a1-4c19-98df-18add4e0690c',
        competitionUnitId: res?.competitionUnitId || competitionGroupId,
        marketDate: res?.marketDate || new Date().toISOString().slice(0, 10),
        generatedAt: res?.generatedAt || new Date().toISOString(),
        closesAt: resClosesAt,
        closes_at: resClosesAt,
      });

      this.ui.showNotification(
        `Agentes libres actualizados: ${mapped.length} disponibles`,
        'success'
      );
      return mapped;
    } catch (err: any) {
      const msg = err?.message || 'Error al obtener la lista de agentes libres';
      this.marketError.set(msg);
      this.ui.showNotification(msg, 'error');
      return this.freeAgents();
    } finally {
      this.isMarketLoading.set(false);
    }
  }

  mapBackendPosition(backendPos?: string | null): Position {
    if (!backendPos) return 'MED';
    const upper = backendPos.toUpperCase();
    if (upper === 'GOALKEEPER' || upper === 'POR' || upper === 'GK') return 'POR';
    if (upper === 'DEFENDER' || upper === 'DEF' || upper === 'DF') return 'DEF';
    if (upper === 'MIDFIELDER' || upper === 'MED' || upper === 'MF') return 'MED';
    if (upper === 'FORWARD' || upper === 'DEL' || upper === 'FW' || upper === 'ST') return 'DEL';
    return 'MED';
  }

  /**
   * PUT /api/clubs/{clubId}/lineup-selection
   * Guarda conjuntamente la formación, los 11 titulares y el banquillo (0-5 suplentes).
   */
  async saveLineup(): Promise<{
    success: boolean;
    error?: string;
    status?: number;
  }> {
    const assignedCount = this.lineupSlots().filter((s) => s.playerId !== null).length;
    if (assignedCount !== 11) {
      const msg = `Debes alinear exactamente 11 jugadores titulares (actualmente: ${assignedCount}/11)`;
      this.ui.showNotification(msg, 'error');
      return {
        success: false,
        error: msg,
        status: 400,
      };
    }

    const currentBench = this.lineupBench();
    if (currentBench.length > 5) {
      const msg = 'El banquillo admite como máximo 5 suplentes';
      this.ui.showNotification(msg, 'error');
      return {
        success: false,
        error: msg,
        status: 400,
      };
    }

    const starterIds = this.lineupSlots()
      .map((s) => s.playerId)
      .filter((id): id is string => Boolean(id));
    const allSelectedIds = [...starterIds, ...currentBench];
    if (new Set(allSelectedIds).size !== allSelectedIds.length) {
      const msg = 'Los suplentes deben ser distintos entre sí y estar fuera del once titular';
      this.ui.showNotification(msg, 'error');
      return {
        success: false,
        error: msg,
        status: 400,
      };
    }

    const clubId = this.activeUserClubId() || this.userClub().id || 'default';
    const payload: SaveLineupSelectionPayload = {
      formation: this.activeFormation(),
      expectedVersion: this.lineupSelectionVersion(),
      players: this.lineupSlots().map((slot, index) => ({
        slot: index + 1,
        playerInstanceId: slot.playerId || '',
      })),
      bench: currentBench,
    };

    try {
      if (clubId && clubId !== 'default') {
        const res = await squadApi.saveLineupSelection(clubId, payload);
        if (res && typeof res.version === 'number') {
          this.lineupSelectionVersion.set(res.version);
          this.lineupVersion.set(res.version);
        }
        if (res.formation) {
          this.activeFormation.set(res.formation);
        }
        if (Array.isArray(res.bench)) {
          this.lineupBench.set(res.bench);
        }
        this.persist(`${STORAGE_KEY}_${clubId}_lineup`, this.lineupSlots());
        this.persist(`${STORAGE_KEY}_${clubId}_bench`, this.lineupBench());
        this.persist(`${STORAGE_KEY}_${clubId}_lineup_version`, this.lineupSelectionVersion());
        this.ui.showNotification('¡Alineación y banquillo guardados con éxito!', 'success');
        return { success: true, status: 200 };
      }
    } catch (err: any) {
      const msg = err?.message || 'Error al guardar la alineación y el banquillo';
      this.ui.showNotification(msg, 'error');
      return {
        success: false,
        error: msg,
        status: err?.status || 500,
      };
    }

    // Fallback offline / default club
    this.persist(`${STORAGE_KEY}_${clubId}_lineup`, this.lineupSlots());
    this.persist(`${STORAGE_KEY}_${clubId}_bench`, this.lineupBench());
    this.ui.showNotification('¡Alineación y banquillo guardados con éxito!', 'success');
    return { success: true, status: 200 };
  }

  reloadLineup(): LineupSlot[] {
    const clubId = this.userClub().id || 'default';
    try {
      const saved = clubStorage.getItem(`${STORAGE_KEY}_${clubId}_lineup`);
      if (saved) {
        const slots: LineupSlot[] = JSON.parse(saved);
        this.lineupSlots.set(slots);
        const savedVer = clubStorage.getItem(`${STORAGE_KEY}_${clubId}_lineup_version`);
        if (savedVer) {
          this.lineupVersion.set(Number(savedVer));
          this.lineupSelectionVersion.set(Number(savedVer));
        }
        const savedBench = clubStorage.getItem(`${STORAGE_KEY}_${clubId}_bench`);
        if (savedBench) {
          this.lineupBench.set(JSON.parse(savedBench));
        }
        this.ui.showNotification('Alineación recargada desde el almacenamiento', 'info');
        return slots;
      }
    } catch {}
    this.ui.showNotification('Alineación sincronizada', 'info');
    return this.lineupSlots();
  }

  loadSquadData(
    clubs: Club[],
    allPlayers: Player[],
    lineupSlots?: LineupSlot[]
  ): void {
    this.clubs.set(clubs);
    this.allPlayers.set(allPlayers);
    const clubId = this.userClub().id || 'default';
    if (typeof clubStorage !== 'undefined') {
      const saved = clubStorage.getItem(`${STORAGE_KEY}_${clubId}_lineup`);
      const savedVer = clubStorage.getItem(`${STORAGE_KEY}_${clubId}_lineup_version`);
      const savedBench = clubStorage.getItem(`${STORAGE_KEY}_${clubId}_bench`);
      if (saved) {
        try {
          this.lineupSlots.set(JSON.parse(saved));
          if (savedVer) {
            this.lineupVersion.set(Number(savedVer));
            this.lineupSelectionVersion.set(Number(savedVer));
          }
          if (savedBench) {
            this.lineupBench.set(JSON.parse(savedBench));
          }
          return;
        } catch {}
      }
    }
    if (lineupSlots) {
      this.lineupSlots.set(lineupSlots);
    }
  }

  private persist(key: string, data: any) {
    try {
      clubStorage.setItem(key, JSON.stringify(data));
    } catch {
      // ignore
    }
  }

  private getInitialClubs(): Club[] {
    return [];
  }

  private getInitialPlayers(): Player[] {
    return [];
  }

  private getInitialLineupSlots(): LineupSlot[] {
    return [];
  }
}
